/**
 * Root Reducer
 */
import { combineReducers } from "redux";
import AppReducer from "./store/app/appReducer";
import { aaSlice } from "./store/app/aaSlice";

// Combine all reducers into one root reducer
export default combineReducers({
  app: AppReducer,
  aa:aaSlice.reducer
});
